import { FunctionComponent } from "react";
import { Text } from "../text";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";

interface Props {
  title?: string;
  content: string;
  littleText?: string;
  size?: "small" | "large";
}

const KeyValueInsights: FunctionComponent<Props> = ({
  title,
  content,
  littleText,
  size = "large",
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <Text
        fontSize={size === "large" ? "11px" : "9px"}
        fontWeight={"600"}
        sx={{
          color: theme.palette.grey[600],
        }}
      >
        {title}
      </Text>
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
        }}
      >
        <Text fontSize={size === "large" ? "24px" : "14px"} fontWeight={"700"}>
          {content}
        </Text>
        <Text
          fontSize={size === "large" ? "11px" : "9px"}
          fontWeight={"400"}
          ml={"5px"}
        >
          {littleText}
        </Text>
      </div>
    </>
  );
};

export default KeyValueInsights;
